"use client";

import Image, { type ImageProps } from "next/image";
import { useCallback, useEffect, useState } from "react";

const FALLBACK = "/blog/hero-fallback.svg";

type Props = Omit<ImageProps, "src" | "onError"> & {
  src: string;
  alt: string;
};

/**
 * Remote hero/inline images with a local SVG fallback if Unsplash/CDN fails.
 * Resets when `src` changes (client navigation between posts).
 */
export function SafeRemoteImage({ src, alt, className, ...rest }: Props) {
  const [uri, setUri] = useState(src);

  useEffect(() => {
    setUri(src);
  }, [src]);

  const onError = useCallback(() => {
    setUri((u) => (u === FALLBACK ? u : FALLBACK));
  }, []);

  return <Image {...rest} src={uri} alt={alt} className={className} onError={onError} />;
}
